import React from 'react';

import { AppSettings } from '@/app/AppSettings';
import { Log } from '@/parsing/Log';

import { BookmarkFab } from './BookmarkFab';
import { LogViewerPostProcessing } from './LogViewerPostProcessing';
import { NetworkOutcomeFilter } from './NetworkOutcomeFilter';
import {
  LogViewerTable,
  LogViewerTableDelegate,
  PostProcessingDelegate,
} from './table/LogViewerTable';
import { LogViewerTableRowModel } from './table/LogViewerTableRowModel';

type Props = {
  log: Log;
  postProcessing: LogViewerPostProcessing;
  postProcessingDelegate: PostProcessingDelegate;
  settings: AppSettings;
  networkOutcomeFilter: NetworkOutcomeFilter;
  onSetShowBookmarksInSettings: (showBookmarks: boolean) => void;
  onNoBugButtonFound?: () => void;
};

type State = {
  bookmarkedRowModels: LogViewerTableRowModel[];
};

export class LogViewer extends React.Component<Props, State> implements LogViewerTableDelegate {
  private logViewerTable = React.createRef<LogViewerTable>();

  constructor(props: Props) {
    super(props);

    this.state = {
      bookmarkedRowModels: [],
    };
  }

  render() {
    return (
      <div className="logViewer">
        <LogViewerTable
          ref={this.logViewerTable}
          log={this.props.log}
          postProcessing={this.props.postProcessing}
          postProcessingDelegate={this.props.postProcessingDelegate}
          settings={this.props.settings}
          networkOutcomeFilter={this.props.networkOutcomeFilter}
          delegate={this}
        />

        <BookmarkFab
          topOffset={
            16 +
            (this.logViewerTable.current?.shouldShowHeader
              ? this.logViewerTable.current.headerHeight
              : 0)
          }
          rightOffset={
            16 + (this.props.settings.enableMap ? this.logViewerTable.current?.mapWidth || 0 : 0)
          }
          settings={this.props.settings}
          bookmarkedRowModels={this.state.bookmarkedRowModels}
          onOpenChange={(open) => {
            this.props.onSetShowBookmarksInSettings(open);
          }}
          onRequestScrollToRow={(rowModel) => {
            if (!this.logViewerTable.current) {
              return;
            }

            const index = rowModel.data.indexAfterApplyingFilters;
            if (typeof index !== 'undefined') {
              this.logViewerTable.current.onRequestScrollToRowWithIndexAfterFiltering(index);
              this.logViewerTable.current.model.selectedRowIndexBeforeFiltering =
                rowModel.data.indexBeforeApplyingFilters;
            }
          }}
          onRequestRemoveAll={() => {
            this.logViewerTable.current?.model.deleteAllBookmarks();
          }}
          onRequestRemoveBookmark={(rowModel) => {
            const index = rowModel.data.indexAfterApplyingFilters;
            if (typeof index !== 'undefined') {
              this.logViewerTable.current?.model.deleteBookmarkWithIndexBeforeFiltering(
                rowModel.data.indexBeforeApplyingFilters,
              );
            }
          }}
        />
      </div>
    );
  }

  jumpToSearchTerm(searchId: string, termIndex: number) {
    if (this.logViewerTable.current) {
      this.logViewerTable.current.jumpToSearchTerm(searchId, termIndex);
    }
  }

  // MARK: - LogViewerTableDelegate

  onBookmarkedRowModelsChange(rowModels: LogViewerTableRowModel[]): void {
    this.setState({
      bookmarkedRowModels: rowModels,
    });
  }

  onNoBugButtonFound(): void {
    this.props.onNoBugButtonFound?.();
  }
}
